module.exports = __webpack_public_path__ + "static/media/scanner-keyboard.7f59c113.svg";